import { ContentState, convertToRaw, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './RichTextEditor.css';

const RichTextEditor = ({ getContent, htmlContent }) => {
    const [editorState, setEditorState] = useState(() => {
        if (htmlContent) {
            let convertedToHTML = decodeURIComponent(htmlContent);
            const blocksFromHtml = htmlToDraft(convertedToHTML);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            return EditorState.createWithContent(contentState);
        }
        return EditorState.createEmpty();
    });

    const handleEditorChange = (state) => {
        setEditorState(state);
    };

    useEffect(() => {
        getContent(convertToRaw(editorState.getCurrentContent()));
    }, [editorState, getContent])

    const embedVideoCallBack = (link) => {
        if (link.indexOf('youtu') >= 0) {
            link = link.replace('watch?v=','embed/');
            link = link.replace('/watch/', '/embed/');
            link = link.replace('youtu.be/','youtube.com/embed/');
            link = link.split('&')[0];
        }
        return link
    }

    return (
        <div>
            <Editor
                editorState={editorState}
                onEditorStateChange={handleEditorChange}
                wrapperClassName='wrapper-class'
                editorClassName='editor-class'
                toolbarClassName='toolbar-class'
                toolbar={{
                    embedded:{
                        embedCallback: embedVideoCallBack
                    }
                }}
            />
        </div>
    );
};

export default RichTextEditor;
